import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import ResourcePage from "@/pages/ResourcePage";
import ReaderLayout from "@/components/ReaderLayout";
import AdminPanel from "@/pages/admin/AdminPanel";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminEditor from "@/pages/admin/AdminEditor";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center" data-testid="loading-screen">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#F5C518] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 text-sm">Loading...</p>
      </div>
    </div>
  );
}

function ReaderPage({ children }) {
  return (
    <ProtectedRoute>
      <ReaderLayout>{children}</ReaderLayout>
    </ProtectedRoute>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={user.role === 'admin' ? '/dashboard' : '/dashboard'} replace /> : <AuthPage />} />
      <Route path="/dashboard" element={<ReaderPage><Dashboard /></ReaderPage>} />
      <Route path="/resource/:urlPath" element={<ReaderPage><ResourcePage /></ReaderPage>} />
      <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>}>
        <Route index element={<AdminAnalytics />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="content" element={<AdminEditor />} />
        <Route path="content/:resourceId" element={<AdminEditor />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
